module.exports = __webpack_public_path__ + "img/bb.45f36d91.png";